import { Box, Heading, Text } from '@chakra-ui/react'
import Header from '../Header'
import PageTransition from '../components/PageTransition'

const OptionsHeatMap = (): JSX.Element => (
  <>
    <Header title="Options Heat Map" subtitle="Visualize options market data" />
    <PageTransition>
      <Box p={4}>
        <Heading as="h2" size="xl" mb={4}>Options Heat Map</Heading>
        <Text fontSize="md">This page will display a heat map for options market data, helping you visualize trends and opportunities.</Text>
      </Box>
    </PageTransition>
  </>
)

export default OptionsHeatMap
